export default {
    UNKNOWN: 'unknown',
    POOR: 'poor',
    FAIR: 'fair',
    GOOD: 'good',
    PREQUALIFIED: 'prequalified',
};
